module.exports = __webpack_public_path__ + "img/PayMethod-PxPay.fd3303d8.png";